import { SvgIcon, SvgIconProps } from '@material-ui/core'

export default function FolderCurvedIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props} fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.7886 15.4756H7.19565C6.78165 15.4756 6.44565 15.1396 6.44565 14.7256C6.44565 14.3116 6.78165 13.9756 7.19565 13.9756H16.7886C17.2026 13.9756 17.5386 14.3116 17.5386 14.7256C17.5386 15.1396 17.2026 15.4756 16.7886 15.4756ZM20.2916 7.25362C19.1946 6.07162 17.7956 6.09962 16.5626 6.12162C15.7896 6.13562 15.0586 6.15062 14.5366 5.85262C13.8916 5.48562 13.6686 5.06962 13.4096 4.58662C13.1236 4.05262 12.7996 3.44762 11.9186 2.97162C10.2926 2.09562 8.38365 1.92462 5.91165 2.43462C3.46865 2.93462 1.88965 5.09962 1.88965 7.94962V14.0156C1.88965 21.2876 6.08065 21.8506 11.9996 21.8506C17.7276 21.8506 22.1096 21.2736 22.1096 13.9886C22.1096 12.2036 22.1096 9.21562 20.2916 7.25362Z"
                fill="currentColor"
            />
        </SvgIcon>
    )
}
